(function() {

  'use strict';

  function PedidoCtrl($scope, $rootScope, $state, $filter, $uibModal, localStorageService, Pedido, Encomenda, Cliente, Cep) {

    $rootScope.alerts = [];

    $scope.$on('pedido:encomenda:adicionar', function(event, encomenda, desconto, mandaeEscolhe, normalApresentado) {
      var pedido = Pedido.getPedido();

        Encomenda.criar(pedido, encomenda)
          .then(function(remessaCriada) {

            pedido.remessas.push(remessaCriada);
            Pedido.setPedido(pedido);

            $state.go('pedido.encomendas');
          })
          .catch(function(err) {
            // Transmitir erro para o controller filho via broadcast
            $scope.$broadcast('pedido:encomenda:erro', err);
          });

    });

    $scope.$on('pedido:encomenda:alterar', function(event, order) {
      var encomenda = _.omit(order, 'plataforma'); // API não suporta a chave `plataforma`
      delete encomenda.codigoRastreamento;
      delete encomenda.dataHoraPrevisaoEntrega;
      Encomenda.atualizar(Pedido.getPedido(), encomenda)
        .then(function(encomendaAtualizada) {
          encomendaAtualizada.plataforma = order.plataforma;
          // Procura encomenda antiga na lista.
          var encomendaAntiga = $filter('filter')(Pedido.getPedido().remessas, {
            id: encomendaAtualizada.id
          }, true)[0];
          // Procura index da encomenda antiga na lista.
          var index = Pedido.getPedido().remessas.indexOf(encomendaAntiga);
          // Remove encomenda antiga na lista.
          Pedido.getPedido().remessas.splice(index, 1);
          // Adiociona encomenda atualizada na lista.
          Pedido.getPedido().remessas.push(encomendaAtualizada);
          $state.go('pedido.encomendas', {
            retornoDaEdicao: true
          });
        })
        .catch(function(err) {
          // Transmitir erro para o controller filho via broadcast
          $scope.$broadcast('pedido:encomenda:erro', err);
        });
    });

    function returnInfoTEX(remessas) {
      var i = 0;
      var eligiblePackages = 0;
      var mandaeOptionTRUE = 0;
      var mandaeOptionFALSE = 0;
      var NF = 0;
      var NFCheck = null;

      for (i in remessas) {
        if ((remessas[i].mandaeEscolhe == true || remessas[i].mandaeEscolhe == false) && (remessas[i].servicoEnvio == 'MandaeExpress' || remessas[i].servicoEnvio == 'MandaeEconomico')) {
          eligiblePackages = eligiblePackages + 1;
          if (remessas[i].tipoDocumentoOrigem == 'NFe') {
            NF = NF + 1;
          }
        }
        if (remessas[i].mandaeEscolhe == false) {
          mandaeOptionFALSE = mandaeOptionFALSE + 1;
        } else if (remessas[i].mandaeEscolhe == true) {
          mandaeOptionTRUE = mandaeOptionTRUE + 1;
        }
      }

      if (NF != 0 && (NF === eligiblePackages)) {
        NFCheck = true;
      } else if (NF !== eligiblePackages) {
        NFCheck = false;
      }

      var data = {
        eligiblePackages: eligiblePackages,
        mandaeOptionTRUE: mandaeOptionTRUE,
        mandaeOptionFALSE: mandaeOptionFALSE,
        NF: NF,
        NFCheck: NFCheck
      };

      return data;
    }

    $scope.$on('auth:logout', function(event) {
      Pedido.novoPedido();
    });

    $scope.$on('erroEncontrado', function(event, erro) {
      $scope.addAlert(erro);
    });

    $scope.$on('limparErros', function(event) {
      $rootScope.alerts = [];
    });

    $scope.$on('pedido:criar-novo', function(event) {
      //$scope.novoPedidoOuUltimoIncompleto();
    });

    $scope.addAlert = function(alert) {
      $rootScope.alerts = [];

      $rootScope.alerts.push({
        type: 'danger',
        msg: alert
      });
    };

    $scope.closeAlert = function(index) {
      $rootScope.alerts.splice(index, 1);
    };

    $scope.getTelefoneCliente = function() {
      var pedido = Pedido.getPedido();
      return Cliente.getTelefone(pedido.cliente);
    }

    $scope.getCpfCliente = function() {
      var pedido = Pedido.getPedido();
      return pedido.cliente != null ? pedido.cliente.cpf : null;
    }

    $scope.getCnpjCliente = function() {
      var pedido = Pedido.getPedido();
      return pedido.cliente != null ? pedido.cliente.cnpj : null;
    }

    $scope.tratarErrosBackEnd = function(err) {
      $("html, body").animate({ scrollTop: 0 }, 500);
      if (err != null && err.data != null) {
        var errorMessages = _.values(err.data.erros).join(',');
        $scope.addAlert(errorMessages);
      }
    }

    $scope.temPedidoAtivo = function() {
      return Pedido.temPedidoAtivo();
    };

    function irEscolherVeiculo() {
      var mostrarModal = localStorageService.cookie.get("checkAlertAreaPostagem") != null;

      if (Cep.diaAdicional() > 0 && !mostrarModal) {
        var modalVeiculo = $uibModal.open({
          animation: false,
          windowClass: 'modal-area-postagem-d-mais-n',
          templateUrl: 'area-postagem-d-mais-n.html',
          controller: 'ModalAreaPostagemCtrl'
        }).result.then(function(result) {
          $state.go("pedido.veiculo");
        }, function(result) {
          $state.go("pedido.veiculo");
        });
      } else {
        $state.go("pedido.veiculo");
      }
    }

    function modalForaDaArea() {
      var modalForaDaArea = $uibModal.open({
        animation: false,
        windowClass: 'modal-fora-area',
        templateUrl: 'modal-fora-area.html',
        controller: 'ModalForaAreaCtrl'
      });
    }
  };

  angular
    .module('mandaeApp')
    .controller('PedidoCtrl', PedidoCtrl);
})();
